import * as React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../Components/Card';
import { Button } from '../Components/Button';
import { Icon } from '../Icons/Icon';
import './Consulting.css'
import FadeIn from '../Animations/FadeIn';
import { Link } from 'react-router-dom';
import ConsultingPricingService, { ConsultingPricingPublicDto, calculateConsultingQuote } from '../DataService/ConsultingPricingService';
export const Consulting = () => {
  const [expandedFAQ, setExpandedFAQ] = React.useState<number | null>(null);
  const [pricingData, setPricingData] = React.useState<ConsultingPricingPublicDto | null>(null);
  
  const toggleFAQ = (index: number) => {
    setExpandedFAQ(expandedFAQ === index ? null : index);
  };
    const therapyFeatures = [
    "Förstå dina känslor och mönster",
    "Bryta negativa tankebanor", 
    "Utveckla starkare självmedkänsla och självkännedom",
    "Skapa hälsosamma strategier för ett mer harmoniskt liv"
  ];

  const coachingFeatures = [
    "Hitta tydliga och inspirerande mål",
    "Skapa en konkret plan för att nå dem",
    "Identifiera och maximera dina styrkor", 
    "Hålla fokus, motivation och ansvar för din utveckling"
  ];

  React.useEffect(() => {
    let mounted = true;

    const loadPricing = async () => {
      const data = await ConsultingPricingService.getPublic();
      if (mounted) setPricingData(data);
    };

    void loadPricing();

    return () => {
      mounted = false;
    };
  }, []);

  const quoteForFive = calculateConsultingQuote(
    pricingData?.config.baseSessionPrice ?? 700,
    pricingData?.rules ?? [],
    5
  );
  const faqData = [
    {
      question: "Hur bokar jag en tid?",
      answer: "Du kan boka direkt här på hemsidan i bokningssystemet. Vill du hellre skicka ett mejl så går det lika bra – välj det som känns enklast för dig. Det första samtalet är alltid ett kostnadsfritt introduktionssamtal helt utan förpliktelser."
    },
    {
      question: "Behöver jag veta exakt vad jag vill arbeta med?",
      answer: "Nej. Vi börjar där du är."
    },
    {
      question: "Hur många samtal behövs?",
      answer: "Det är individuellt. Vissa får mycket ut av ett fåtal, andra vill arbeta mer långsiktigt. Vi pratar om vad som känns rätt för dig."
    },
    {
      question: "Blir det billigare om jag bokar fler samtal på en gång? ",
      answer: " Ja, vid bokning av 5 samtal eller fler får du ett paketpris vilket ger dig 10 % billigare kostnad."
    },
    {
      question: "Kan jag avboka om något dyker upp?",
      answer: "Självklart, livet händer! Du kan av- eller omboka fram till 24 timmar innan vår tid. Senare än så behöver jag tyvärr ta betalt för samtalet."
    },
    {
      question: "Kan jag boka enskilda samtal utan att vara medlem i GROW?",
      answer: "Ja, du kan boka enskilda fristående 1:1 samtal."
    },
    {
      question: "Ses vi online?",
      answer: "Ja! Vi ses alltid online via videosamtal eller om du föredrar chatt. Många uppskattar flexibiliteten med att kunna sitta hemma. Jag sköter det tekniska. Du får enkelt en länk via e-post som du bara behöver trycka på för att starta i gång samtalet."
    },
    {
      question: "Vad kan jag ta upp under samtalen?",
      answer: "Allt som känns viktigt för dig. Det kan handla om stress, relationer, självkänsla, livsbalans, hälsa, livsstilsförändring, karriär, förändringar eller något helt annat."
    },
    {
      question: "Är detta samma sak som psykiatrisk vård?",
      answer: "Nej, det är inte sjukvård utan ett kompletterande stöd för dig som vill arbeta med ditt mående, din utveckling och dina livsvanor."
    },
     {
      question: "Är samtalen konfidentiella?",
      answer: "Ja, allting du delar stannar mellan oss. Jag följer sekretessregler för att du ska känna dig trygg."
    },
    {
      question: "Kan jag utnyttja mitt friskvårdsbidrag?",
      answer: "Ja, det går bra. Men det kan vara lite olika vad arbetsgivaren har bestämt ska ingå i friskvårdsbidraget. Så hör först med din arbetsgivare för säkerhetsskull."
    },
    
  ];
  const benefits = [
    {
      icon: <Icon.Heart />,
      title: "Trygga, förtroliga samtal",
      description: "Du delar i din egen takt, jag lyssnar med omtanke. Vi möts online men vi arbetar enligt samma premisser som på en konventionell mottagning och ett fysiskt samtalsrum. Tystnadslöftet gäller!"
    },
    {
      icon: <Icon.SimpleGroup fill="white"/>,
      title: "Flexibelt och tillgängligt", 
      description: "Möt mig online, var du än befinner dig. Du väljer format – videosamtal eller chatt, vad som känns bäst för dig."
    },
    {
      icon: <Icon.CheckMarkCross/>,
      title: "Du slipper vänta",
      description: "Få hjälp snabbt, utan långa köer."
    },
    {
      icon: <Icon.StarRainbow/>,
      title: "Individuellt anpassat",
      description: "Vi utgår från dig, dina känslor och dina behov."
    }
  ];

  return (
    <div className="consulting">
     
      
      {/* Hero Section */}
      <section className="consutling-hero-section">
        <div className="consulting-hero-container"></div>
        <div className="consulting-hero-item-container">
          <h1 className="consulting-hero-text-heading">
            Samtalsterapi & coaching online
          </h1>
          <p className="consulting-hero-paragraph">
            Ditt välmående i fokus – flexibelt, tillgängligt och tryggt!
          </p>
         <Button className='basic-button' text={<><Icon.Calendar width={30} height={30}/>Boka samtal</>} style={{maxWidth:'300px',minWidth:'300px',cursor:'pointer',display:'flex',justifyContent:'center',alignItems:'center'}}/>
        </div>
      </section>

      {/* Introduction */}
      <section className="consulting-introduction">
        <div className="consulting-introduction-container">
          <div className="prose-custom">
            <FadeIn>
            <p>
              Livet går upp och ner, och ibland behöver vi någon vid vår sida. Kanske kämpar du med stress, 
              ångest eller självtvivel? Kanske längtar du efter förändring, men vet inte var du ska börja? 
              Oavsett om du söker stöd för att hantera det förflutna eller vägledning för att forma din framtid, 
              finns jag här för dig.
            </p>
            </FadeIn>
            <FadeIn>
            <p>
              Samtalsterapi handlar inte bara om att lösa problem – det handlar om att förstå dig själv, 
              bryta negativa mönster och hitta en riktning som känns meningsfull. Genom att investera i ditt 
              välmående stärker du din självkänsla, förbättrar dina relationer och skapar en stabil grund för 
              ett liv där du trivs – med dig själv och din omgivning.
            </p>
            </FadeIn>
            <FadeIn>
          <p className="consulting-introduction-second-paragraph">
              Här får du både samtalsterapi och coaching online – två olika men kompletterande sätt att 
              arbeta med ditt mående och din personliga utveckling. Online, enkelt och tryggt
            </p>
            </FadeIn>
          </div>
        </div>
      </section>

      <section className="consulting-pricing-highlight">
        <div className="consulting-pricing-highlight-container">
          <FadeIn>
            <h2>Aktuellt pris</h2>
            <p>{pricingData?.config.basePriceText || `${pricingData?.config.baseSessionPrice ?? 700} kr / samtal`}</p>
            <div className="consulting-pricing-highlight-box">
              {pricingData?.rules?.length ? pricingData.rules.map(rule => (
                <div key={rule.id} className="consulting-pricing-highlight-rule">
                  <strong>{rule.displayText}</strong>
                </div>
              )) : (
                <div className="consulting-pricing-highlight-rule">
                  <strong>Ingen aktiv paketrabatt just nu</strong>
                </div>
              )}
            </div>
            <p>
              Exempel: 5 samtal kostar {quoteForFive.totalAmount.toLocaleString('sv-SE')} kr
              {quoteForFive.appliedRule ? ` med aktuell regel: ${quoteForFive.appliedRule.displayText}` : ''}
              {quoteForFive.discountAmount > 0 ? ` och du sparar ${quoteForFive.discountAmount.toLocaleString('sv-SE')} kr` : ''}.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Service Overview Cards */}
      <section className="consulting-overwiev">
        <div className="consulting-overwiev-container">
          <div className="consulting-overwiev-grid">
            <FadeIn>
            <Card className="consulting-overwiev-grid-card">
              <CardHeader className="consulting-overwiev-grid-card-heading">
                <Icon.Brain />
                <CardTitle className="consulting-overwiev-grid-card-title">Samtalsterapi</CardTitle>
              </CardHeader>
              <CardContent style={{padding:'0rem 1.5rem 0 1.5rem'}}>
                <p className="consulting-overwiev-grid-card-second-paragraph">
                  För dig som vill bearbeta känslor, förstå dig själv på djupet och hitta verktyg för att må bättre.
                </p>
              </CardContent>
            </Card>
            </FadeIn>
            <FadeIn>
            <Card className="consulting-overwiev-grid-card">
              <CardHeader className="consulting-overwiev-grid-card-heading">
                <Icon.Bullseye />
                <CardTitle className="consulting-overwiev-grid-card-title">Coaching</CardTitle>
              </CardHeader>
              <CardContent style={{padding:'0rem 1.5rem 0 1.5rem'}}>
                <p className="consulting-overwiev-grid-card-second-paragraph">
                  För dig som vill ha tydlig vägledning, sätta mål och ta konkreta steg mot den förändring du önskar.
                </p>
              </CardContent>
            </Card>
            </FadeIn>
          </div>

          {/* Benefits */}
          <div className="consulting-benefits-grid">
            {benefits.map((benefit, index) => (
              <FadeIn>
              <div key={index} className="consulting-benefits-grid-item-container">
                <div className="consulting-benefits-grid-item-container-icon">
                  {/* <benefit.icon className="h-6 w-6 text-[#E16A54] mt-1" /> */}
                </div>
                <div>
                  <h3 className="consulting-benefits-grid-item-container-title"><Icon.AlternativeLeaf/> {benefit.title}</h3>
                  <p className="consulting-benefits-grid-item-container-description">{benefit.description}</p>
                </div>
              </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="consulting-calltoaction">
        <div className="consulting-calltoaction-container">
          <FadeIn>
          <h2 className="consulting-calltoaction-heading">
            <Icon.Star width={40} height={40}/> Ta det första steget redan idag!
          </h2>
          </FadeIn>
          <FadeIn>
          <p className="consulting-calltoaction-paragraph">
            Låt oss tillsammans hitta vägen mot ett starkare, mer balanserat och lyckligare du.
          </p>
          </FadeIn>
           <FadeIn>
          <p className="consulting-calltoaction-paragraph">
            Boka ditt första kostnadsfria introduktionssamtal. 
          </p>
          </FadeIn>
          <FadeIn>
            <Link to={'/booking'}>
          <Button className='submit-button' text={<><Icon.Calendar width={30} height={30}/>BOKA SAMTAL HÄR</>} style={{maxWidth:'250px',cursor:'pointer',display:'flex',justifyContent:'center',alignItems:'center'}}/>
            </Link>
         </FadeIn>
        </div>
      </section>

      {/* Detailed Comparison */}
      <section className="consulting-detalied-comparison">
        <div className="consulting-detalied-padding-container">
          <FadeIn>
          <h2 className="consulting-detalied-heading">
            <Icon.ThinkingAvatar/> Samtalsterapi eller Coaching – vad passar dig?
          </h2>
          </FadeIn>
          <FadeIn>
          <div className="consulting-detailed-porse">
            <p>
              Både samtalsterapi och coaching ger stöd och vägledning, men de har olika fokus och metoder. 
              Vill du få en djupare förståelse för dig själv, bearbeta känslomässiga utmaningar eller hitta 
              nya vägar framåt i livet? Oavsett om du vill läka från det förflutna eller ta konkreta steg mot 
              dina mål, finns rätt stöd för dig.
            </p>
          </div>
          </FadeIn>
          <div className="consulting-detailed-grid">
            {/* Samtalsterapi Section */}
            <Card className="consulting-detailed-card">
            <FadeIn>
              <CardHeader className="consulting-detailed-card-header">
                <div className="consulting-detailed-card-header-items-container">
                  <Icon.ChatCloud  width={50} height={50}/>
                  <div>
                    <CardTitle className="consulting-detailed-card-header-item-title">Samtalsterapi</CardTitle>
                    <p className="consulting-detailed-card-header-item-paragraph">förståelse och läkning</p>
                  </div>
                </div>
              </CardHeader>
              </FadeIn>
              <FadeIn>
              <CardContent className="consulting-detailed-card-content">
                <div className="consulting-detailed-card-content">
                  <p className="consulting-detailed-card-content-paragraph">
                    Förstå ditt förflutna – Stärk din nutid – Skapa din framtid
                  </p>
                  
                  <p className="consulting-detailed-card-content-paragraph-two">
                    Samtalsterapi är en metod som syftar till att hjälpa dig att bearbeta känslomässiga 
                    utmaningar och mentala hinder. Här ligger fokus på att utforska tidigare erfarenheter 
                    och djupt rotade mönster. Genom samtalen ökar du din förståelse för dina känslor och 
                    tankar samt får stöd i att utveckla hälsosamma strategier för att hantera svårigheter.
                  </p>
                  
                  <p className="consulting-detailed-card-content-paragraph-two">
                    Samtalsterapi kan vara särskilt hjälpsamt om du brottas med stress, ångest, depression, 
                    trauman eller andra livsutmaningar. Som terapeut fungerar jag som en trygg guide som 
                    stöttar dig på vägen mot självinsikt, läkande och förändring.
                  </p>

                  <div className="consulting-detailed-card-content-features">
                    <h4 className="consulting-detailed-card-content-features-header">Genom samtal och beprövade tekniker hjälper jag dig med att:</h4>
                    {therapyFeatures.map((feature, index) => (
                      <div key={index} className="consulting-detailed-card-content-features-items-container">
                        <span className="consulting-detailed-card-content-features-items-icon-span"><Icon.Star width={18} height={18}/></span>
                        <span className="consulting-detailed-card-content-features-items-feature-text-span">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
              </FadeIn>
            </Card>

            {/* Coaching Section */}
            <Card className="consulting-detailed-card">
              <FadeIn>
              <CardHeader className="consulting-detailed-card-header-two">
                <div className="consulting-detailed-card-header-items-container">
                  <Icon.Bullseye/>
                  <div>
                    <CardTitle className="consulting-detailed-card-header-item-title-two">Coaching</CardTitle>
                    <p className="consulting-detailed-card-header-item-paragraph">framåt och mot målen</p>
                  </div>
                </div>
              </CardHeader>
              </FadeIn>
              <FadeIn>
              <CardContent className="consulting-detailed-card-content">
                <div className="consulting-detailed-card-content">
                  <p className="consulting-detailed-card-content-paragraph">
                    Fokusera på framtiden – Ta kontroll – Uppnå dina drömmar
                  </p>
                  
                  <p className="consulting-detailed-card-content-paragraph-two">
                    Coaching är en mer målinriktad och framtidsfokuserad metod. Här handlar det om att 
                    identifiera dina styrkor, skapa tydliga mål och utveckla strategier för att nå dit du vill. 
                    Som coach hjälper jag dig att ta konkreta steg mot framgång, vare sig det gäller karriär, 
                    personlig utveckling, hälsa eller andra områden i livet.
                  </p>
                  
                  <p className="consulting-detailed-card-content-paragraph-two">
                    Genom att ställa utmanande frågor, reflektera och skapa handlingsplaner får du stöd i 
                    att övervinna hinder och ta kontroll över din utveckling. Coaching passar dig som vill 
                    maximera din potential och ta din prestation till nästa nivå.
                  </p>

                  <div className="consulting-detailed-card-content-features">
                    <h4 className="consulting-detailed-card-content-features-header">Jag hjälper dig att:</h4>
                    {coachingFeatures.map((feature, index) => (
                      <div key={index} className="consulting-detailed-card-content-features-items-container">
                        <span className="consulting-detailed-card-content-features-items-icon-span"><Icon.Star width={18} height={18}/></span>
                        <span className="consulting-detailed-card-content-features-items-feature-text-span">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </CardContent>
              </FadeIn>
            </Card>
          </div>
        </div>
      </section>

      {/* Decision Section */}
      <section className="consulting-decision">
        <div className="consulting-decision-container">
          <FadeIn>
          <h2 className="consulting-decision-heading">
            <Icon.Bullseye/> Vilket steg tar du idag?
          </h2>
          </FadeIn>
          <div className="consulting-decision-prose">
            <FadeIn>
            <p>
              Ditt val beror på vad du behöver just nu. Om du vill bearbeta känslomässiga svårigheter och 
              få stöd i att hantera inre utmaningar kan samtalsterapi vara det bästa valet. Om du däremot 
              vill ha hjälp att sätta mål, skapa struktur och utveckla dig själv på ett mer handlingskraftigt 
              sätt, kan coaching vara rätt väg.
            </p>
            </FadeIn>
            <FadeIn>
            <p>
              Det går även att kombinera båda metoderna för att få en balanserad och heltäckande 
              utvecklingsresa. Många behöver börja med samtalsterapi för att sen övergå till coaching.
            </p>
            </FadeIn>
            <FadeIn>       
            <p className="consulting-decision-paragraph">
              Ditt välmående och din utveckling är viktig. Oavsett om du söker läkande insikter eller 
              konkreta framsteg, finns en väg framåt för dig. Jag hjälper dig att hitta den. Tillsammans 
              anpassar vi upplägget efter dina unika behov och önskemål.
            </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="consulting-pricing">
        <div className="consulting-pricing-container">
            <FadeIn>
          <Card className="consulting-pricing-container155478w41d">
            <CardHeader className="consulting-pricing-heading">
              <CardTitle className="consulting-pricing-title">
                <Icon.Calendar width={'45px'} height={'45px'}/>
                <span>Pris & Bokning</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="consulting-pricing-content">
              <div className="consulting-pricing-content-margin">
                <div className="consulting-pricing-content-pricing-container">
                  700kr <span className="consulting-pricing-content-pricing-container-span">/ samtal</span>
                </div>
                <div className='consultion-special-pill'>45 minuter</div>
                <div className='consulting-special-separator'/>
                
                <div className="consulting-pricing-options-container2">
                  <p className="consulting-pricing-options-text">Välj betalningsalternativ:</p>
                  <div className="consulting-pricing-options-badges-container">
                    <Icon.SwishIcon/>
                    <Icon.KlarnaPink/>
                  </div>
                </div>
                <Button className='submit-button' text={<><Icon.Calendar width={30} height={30}/>Boka samtal</>} style={{cursor:'pointer',display:'flex',justifyContent:'center',alignItems:'center'}}/>
              </div>
            </CardContent>
          </Card>
            </FadeIn>
            <FadeIn>
          <p className="consulting-pricing-last-paragraph">
            Boka ett första samtal idag och låt oss hitta den bästa vägen för just dig!
          </p>
          </FadeIn>
        </div>
      </section>
       {/* FAQ Section */}
       <section className="section-seven">
         <div className="section-seven-custom-container">
           <FadeIn>
           <h2 className="section-seven-custom-heading">
             FAQ – Vanliga frågor
           </h2>
           </FadeIn>
           <div className="section-seven-custom-space-y">
             {faqData.map((faq, index) => (
               <FadeIn>
               <div key={index} className="section-seven-custom-box">
                 <button
                   className="section-seven-custom-button"
                   onClick={() => toggleFAQ(index)}
                 >
                   <span className="section-seven-custom-text">{faq.question}</span>
                   {expandedFAQ === index ? (
                     <Icon.ArrowUp/>
                   ) : (
                     <Icon.ArrowDown/>
                   )}
                 </button>
                 {expandedFAQ === index && (
                   <div className="section-seven-custom-padding">
                     <p className="section-seven-custom-text-gray">{faq.answer}</p>
                   </div>
                 )}
               </div>
               </FadeIn>
             ))}
           </div>
         </div>
       </section>
    </div>
  );
}
